// Golden Moon: "Buy now" (snippets/buy-now.liquid). A module, so the browser runs it once however many cards render it.

/** @param {string} root @param {string} variantId @param {number} quantity */
function goToCheckout(root, variantId, quantity) {
  window.location.href = `${root}${encodeURIComponent(variantId)}:${quantity}`;
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('[data-buy-now]');
  if (!(button instanceof HTMLElement)) return;

  if (button.dataset.buyNow === 'choose') {
    // A product with options: open the theme's quick-add window (its form has this button too).
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest('product-card');
    const choose = card?.querySelector('.quick-add__button--choose');
    if (choose instanceof HTMLElement) choose.click();
    else if (button.dataset.productUrl) window.location.href = button.dataset.productUrl;
    return;
  }

  if (button.dataset.buyNow === 'form') {
    event.preventDefault();
    const form = button.closest('form');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    // The theme disables "Add to cart" when the chosen variant cannot be bought.
    if (!(idInput instanceof HTMLInputElement) || !idInput.value || idInput.disabled) return;
    if (addButton instanceof HTMLButtonElement && addButton.disabled) return;
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput instanceof HTMLInputElement ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
    goToCheckout(button.dataset.cartRoot || '/cart/', idInput.value, quantity);
  }
});
